import {
  EXPRESS_HOME_DELIVERY,
  EXPRESS_RELAY_POINT,
  H24,
  H48,
  HOME_DELIVERY,
  HOME_DELIVERY_EXPRESS,
  PRE_ORDER_SCHEDULED_DELIVERY_AT_STREET,
  PRE_ORDER_SCHEDULED_DELIVERY_ROOM_OF_CHOICE,
  RELAY_POINT,
  RELAY_POINT_EXPRESS,
  ROOM_OF_CHOICE,
} from '@/domains/productDelivery/DeliveryPromisesList/constants';
import {
  atStreet,
  homeDelivery,
  homeDeliveryH24,
  homeDeliveryH48,
  pickUpDelivery,
  pickUpDeliveryH24,
  pickUpDeliveryH48,
  preOrderRoomOfChoice,
  roomOfChoice,
} from '@/productDiscovery/ProductPage/common/modules/Delivery/translations';

export const getDeliveryMode = (type: string, expressMode?: string) => {
  switch (type) {
    case HOME_DELIVERY:
    case HOME_DELIVERY_EXPRESS:
    case EXPRESS_HOME_DELIVERY:
      switch (expressMode) {
        case H24:
          return homeDeliveryH24;
        case H48:
          return homeDeliveryH48;
        default:
          return homeDelivery;
      }
    case PRE_ORDER_SCHEDULED_DELIVERY_ROOM_OF_CHOICE:
      return preOrderRoomOfChoice;
    case PRE_ORDER_SCHEDULED_DELIVERY_AT_STREET:
      return atStreet;
    case ROOM_OF_CHOICE:
      return roomOfChoice;
    case RELAY_POINT:
    case RELAY_POINT_EXPRESS:
    case EXPRESS_RELAY_POINT:
      switch (expressMode) {
        case H24:
          return pickUpDeliveryH24;
        case H48:
          return pickUpDeliveryH48;
        default:
          return pickUpDelivery;
      }
    default:
      return pickUpDelivery;
  }
};
